import React from 'react';
const SITE_URL = 'https://www.californiamesotheliomaclaims.com';
const FIRM_NAME = 'California Mesothelioma Claims';
const PHONE = '+1-805-770-9317';
const EMAIL = 'help@californiamesotheliomaclaims.com';
export function SeoHead() {
  const legalServiceSchema = {
    '@context': 'https://schema.org',
    '@type': 'LegalService',
    '@id': `${SITE_URL}/#organization`,
    name: FIRM_NAME,
    alternateName: 'California Mesothelioma Claims Law Group',
    description: 'California Mesothelioma Claims is a California law firm dedicated exclusively to mesothelioma and asbestos litigation, recovering over $2 billion for asbestos victims and their families statewide.',
    url: SITE_URL,
    telephone: PHONE,
    email: EMAIL,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Los Angeles',
      addressRegion: 'CA',
      addressCountry: 'US'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 34.0522,
      longitude: -118.2437
    },
    areaServed: {
      '@type': 'State',
      name: 'California'
    },
    knowsAbout: ['Mesothelioma litigation', 'Asbestos exposure claims', 'Asbestos trust fund claims', 'Wrongful death lawsuits', 'California asbestos exposure sites'],
    priceRange: 'Contingency fee — no win, no fee',
    openingHours: 'Mo-Su 00:00-23:59'
  };
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    url: SITE_URL,
    name: FIRM_NAME,
    publisher: {
      '@id': `${SITE_URL}/#organization`
    },
    inLanguage: 'en-US'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    '@id': `${SITE_URL}/#faq`,
    mainEntity: [{
      '@type': 'Question',
      name: 'Who is the best mesothelioma lawyer in California?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The best mesothelioma lawyers in California have decades of specific experience with asbestos litigation, a proven track record of multi-million dollar settlements, and operate on a contingency fee basis. California Mesothelioma Claims is widely recognized as a top-tier firm in California due to our specialized focus, extensive resources, and history of securing record verdicts for asbestos victims across the state.'
      }
    }, {
      '@type': 'Question',
      name: 'How much does a mesothelioma attorney cost in California?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Top California mesothelioma attorneys work on a contingency fee basis. This means you pay zero upfront costs, and the law firm only gets paid a percentage of the settlement or verdict if they win your case.'
      }
    }, {
      '@type': 'Question',
      name: 'What is the statute of limitations for mesothelioma in California?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'In California, the statute of limitations for filing a mesothelioma personal injury lawsuit is generally one year from the date of diagnosis or one year from when the patient should have reasonably known the illness was caused by asbestos exposure.'
      }
    }, {
      '@type': 'Question',
      name: 'Do I have to go to court for a mesothelioma lawsuit?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Not necessarily. The vast majority of mesothelioma cases in California are settled out of court before a trial is necessary, often through negotiated settlements with asbestos trust funds or defendant companies.'
      }
    }]
  };
  return <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(legalServiceSchema)
    }} data-id="element-260" data-mp="2xtv821xk76kp" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(websiteSchema)
    }} data-id="element-261" data-mp="3ucb39yhlkzt9" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} data-id="element-262" data-mp="3pionvyk1uhtr" />
    </>;
}